(function ($) {

    function init_add_review_order() {
        $(".add-review-order").off().on("click", function (e) {
            const context = $(this).data("modal-context")
            if (!context || !context.order_id){
                return
            }

            let rating
            const star = $(e.target).closest('svg')
            if (star.length > 0) {
                rating = star.prevAll(".stars").length + 1
            }
            else {
                rating = 0
            }

            gp_ajax({
                url: ghostpress_params.ajax_url + "&action=order_rating",
                type: "post",
                dataType: "json",
                data: {
                    order_id: context.order_id,
                    rating: rating,
                },
                show_loading: true
            })
                .done(function (response) {
                    $(document).trigger(
                        'open_modal',
                        [
                            'my-account-order-review',
                            {
                                order_id: context.order_id,
                                review_id: response.data.review_id ?? "",
                            },
                            true
                        ]
                    )
                })
        })
    }

    $(document).gp_ready(init_add_review_order)

})(jQuery);